import { fork, take } from 'redux-saga/effects'

import getConstants from '../../../constants'

import request from 'services/Request'

import * as actionTypes from '../actionTypes'
import * as api from '../api'

const CONSTANTS = getConstants()

export function* getCMSDataWorker() {
  const args: api.GetStatesForRegionProps = {
    country: CONSTANTS.COUNTRY,
  }

  yield request(actionTypes.CMS_DATA_REQUESTED, api.getCMSResponse, args)
}

export function* getCMSDataSaga() {
  while (true) {
    yield take(actionTypes.CMS_DATA_REQUESTED)
    yield fork(getCMSDataWorker)
  }
}

export default getCMSDataSaga
